import { Component, OnInit } from '@angular/core';
import { GithubService } from 'src/app/services/github.service';

@Component({
  selector: 'app-proyectos',
  templateUrl: './proyectos.component.html',
  styleUrls: ['./proyectos.component.css']
})
export class ProyectosComponent implements OnInit {

  proyectos: [] = [];

  constructor(private github:GithubService) { }

  ngOnInit(): void {
    this.github.getProyectos()
      .subscribe( (resp: any)=>{
        console.log(resp);
        this.proyectos = resp;
      })
  }

}
